import { Box } from '@mui/material';
import { RenderTable } from '../../../components/ui';
import TBody from './TBody';
import THead from './THead';
interface IProps {
  moduleData: any;
  isView: boolean;
  handelDeleteRows: (index: number) => void;
  setIsOpenPopup: React.Dispatch<React.SetStateAction<boolean>>;
  setPartIdx: React.Dispatch<React.SetStateAction<number>>;
  onSubmit: () => void;
}

const TController = ({
  handelDeleteRows,
  moduleData,
  onSubmit,
  isView,
  setIsOpenPopup,
  setPartIdx,
}: IProps) => {
  return (
    <Box>
      <RenderTable scroll="horizontal">
        <THead
          {...{
            moduleData,
            isView,
          }}
        />
        <TBody
          {...{
            handelDeleteRows,
            moduleData,
            isView,
          }}
        />
      </RenderTable>
    </Box>
  );
};

export default TController;
